<template>
    <div class="search-list" v-loading="loading">
        <div v-show="(searchlist.data && searchlist.data.length>0) && loading==false">
            <div class=" search-list-con">
                <div class="lesson-list flex-layout" >
                    <div @click="$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})" class="p-pointer" v-for="(item,i) in searchlist.data" :key="i">
                        <LessonCard :data="item"/>
                    </div>
                </div>
            </div>
            <div class="flex-center">
                <el-pagination background @current-change="currentChange" :current-page="searchlist.current_page" layout="prev, pager, next" :total="searchlist.total" :page-size="15">
                </el-pagination>
            </div>
        </div>
        <div class="mess-without lms-center" v-show="(!searchlist.data || searchlist.data.length==0) && loading==false">
            <div>
                <img src="@p/assets/images/courseempty.png" alt="">
                <div class="not-less">暫無課程</div>
            </div>
        </div>
    </div>
</template>
<script>
import LessonCard from '@p/components/lessonCard';
import { setTimeStr } from '@/utils';
export default {
    data(){
        return {
            searchlist:{},
            loading:'',
        }
    },
    created(){
        if(this.$route.query){
            this.searchChang(this.$route.query.val,this.$route.query.page)
        }
    },
    watch:{
        '$route.query':function(v){
            this.searchChang(v.val,v.page)
        }
    },
    methods:{
        //搜索
        async searchChang(searchStr='',page=1){
            this.loading=true;
            await this.$http.home.getCourseSearch({searchStr,page,take:15}).then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                    this.searchlist=v.data.data;
                }
                this.loading=false;
            }).catch(v=>{this.loading=false;})
        },
        //分页
        currentChange(v){
            // this.searchChang(this.$route.query.val,v)
            this.$router.replace({path:'/search/list',query:{...this.$route.query,page:v}})
        },
        getTime(v){
            return setTimeStr(v)
        },
    },
    components:{ LessonCard },
}
</script>
<style lang="less" scoped>
.search-list{
    margin-top: 16px;
    &-con{
        height: 690px;
    }
    .mess-without{
        height: 602px;
        img{
            display: block;
            widows: 296px;
            height: 296px;
        }
        .not-less{
            text-align: center;
            margin-top: 46px;
            color:rgba(51,51,51,0.70);
            font-size:18px;
        }
    }
}

</style>